// extracted by css-extract-rspack-plugin
export default {"schema":"WJbyk0ftVbQpuJmi"};